import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import RedBtn from "../atoms/button/redBtn";

function ImgPreviewLarge({ fileUrl, onClick }) {
  const navigate = useNavigate();

  return (
    <>
      {fileUrl ? (
        <ImgPreviewWrapper>
          <img
            style={{
              width: "100%",
              height: 280,
              borderRadius: "3px",
              border: "1px solid rgba(255, 255, 255, 0.12)",
            }}
            src={fileUrl}
            alt="이미지"
          />
          <RedBtn onClick={onClick}>삭제</RedBtn>
        </ImgPreviewWrapper>
      ) : null}
    </>
  );
}

export default ImgPreviewLarge;

const ImgPreviewWrapper = styled.div.attrs((props) => {})`
  width: 254px;
  height: 321px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
